import React, { useEffect, useState } from "react";
import EventCategoryServices from "../../services/EventCategoryServices";
import EventServices from "../../services/EventServices";
function UpdateEventCategory({ user, closeModal, onSuccess }) {
    const [formValues, setFormValues] = useState({
        eventId: "",
        ticketName: "",
        price: "",
        ticket_discount: "",
        general_ticket_discount: "",
        description: "",
        status: "Active",
        image: null,
    });

    const [loading, setLoading] = useState(false);
    const [event, setEvent] = useState([])
    const [previewImage, setPreviewImage] = useState(
        "img/placeholder-img.png"
    );
    useEffect(() => {
        if (!user) return;
        setFormValues({
            eventId: user?.eventId?._id || user?.eventId || "",
            ticketName: user?.ticketName || "",
            general_ticket_discount: user?.general_ticket_discount ?? "",
            ticket_discount: user?.ticket_discount ?? "",
            price:
                user?.price !== undefined && user?.price !== null
                    ? String(user.price)
                    : "",
            description: user?.description || "",
            status: user?.status || "Active",
            image: null,
        });

        // =================================================
        // EXISTING TICKET IMAGE
        // =================================================
        if (user?.ticketImage) {
            setPreviewImage(
                `${process.env.REACT_APP_URL}${user.ticketImage}`
            );
        } else {
            setPreviewImage("img/placeholder-img.png");
        }
    }, [user]);

    // =====================================================
    // INPUT CHANGE
    // =====================================================
    const handleInputChange = (event) => {
        const { name, value } = event.target;

        setFormValues((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // =====================================================
    // IMAGE CHANGE
    // =====================================================
    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (!file) return;

        // Preview selected image
        setPreviewImage(URL.createObjectURL(file));

        // Store actual File
        setFormValues((prev) => ({
            ...prev,
            image: file,
        }));
    };
    useEffect(() => {
        const fetchActiveEvents = async () => {
            try {
                const res = await EventServices.getActiveEvents();

                console.log("Active Events:", res);

                if (res?.status) {
                    setEvent(res?.data || []);
                }
            } catch (error) {
                console.error("Get Active Events Error:", error);
            }
        };

        fetchActiveEvents();
    }, []);
    const handleSubmit = async (event) => {
        event.preventDefault();

        // =========================
        // EVENT TICKET ID
        // =========================
        const ticketId = user?._id || user?.id;

        if (!ticketId) {
            alert("Event Ticket ID not found");
            return;
        }

        setLoading(true);

        try {
            const formData = new FormData();

            // =========================
            // TICKET DATA
            // =========================
            formData.append(
                "eventId",
                formValues.eventId
            );
            formData.append(
                "ticketName",
                formValues.ticketName
            );

            formData.append(
                "price",
                formValues.price
            );
            formData.append(
                "ticket_discount",
                formValues.ticket_discount
            );
            formData.append(
                "general_ticket_discount",
                formValues.general_ticket_discount
            );

            formData.append(
                "description",
                formValues.description
            );

            formData.append(
                "status",
                formValues.status
            );

            // =========================
            // IMAGE
            // =========================
            // if (formValues.image) {
            //     formData.append(
            //         "ticketImage",
            //         formValues.image
            //     );
            // }

            // =========================
            // DEBUG FORMDATA
            // =========================
            for (const [key, value] of formData.entries()) {
                console.log(
                    key,
                    value
                );
            }

            // =========================
            // UPDATE API
            // =========================
            const res =
                await EventCategoryServices.updateEventCategory(
                    ticketId,
                    formData
                );

            console.log(
                "Update Ticket Response:",
                res
            );

            if (res?.status) {
                alert(
                    res?.message ||
                    "Event ticket updated successfully"
                );

                onSuccess?.();
                closeModal?.();
            } else {
                alert(
                    res?.message ||
                    "Failed to update event ticket"
                );
            }
        } catch (error) {
            console.error(
                "Failed to update event ticket:",
                error
            );

            alert(
                error?.response?.data?.message ||
                "Failed to update event ticket"
            );
        } finally {
            setLoading(false);
        }
    };

    // =====================================================
    // UI
    // =====================================================
    return (
        <div
            className="modal fade edit-box show d-block"
            id="editModal"
            tabIndex={-1}
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">

                    {/* =========================
                        HEADER
                    ========================== */}
                    <div className="modal-header">
                        <h5 className="modal-title">
                            Event Ticket Edit
                        </h5>

                        <button
                            type="button"
                            className="btn-close"
                            onClick={closeModal}
                            aria-label="Close"
                        />
                    </div>

                    {/* =========================
                        BODY
                    ========================== */}
                    <div className="modal-body">
                        <div className="container-box px-5">
                            <div className="container-box-inner table-reponsive-tabe">
                                <div className="page-details">

                                    <form onSubmit={handleSubmit}>

                                        <div className="row">
                                            <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">
                                                    <label>Select Event *</label>

                                                    <select
                                                        name="eventId"
                                                        value={formValues.eventId}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                    >
                                                        <option value="">Select Event</option>

                                                        {event.map((item) => (
                                                            <option key={item._id} value={item._id}>
                                                                {item.eventName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        Ticket Name
                                                        <span className="red">
                                                            *
                                                        </span>
                                                    </label>

                                                    <input
                                                        type="text"
                                                        name="ticketName"
                                                        className="form-control"
                                                        value={
                                                            formValues.ticketName
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                        placeholder="Enter ticket name"
                                                        required
                                                    />

                                                </div>
                                            </div>

                                            {/* =========================
                                                PRICE
                                            ========================== */}
                                            <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        Ticket Price
                                                        <span className="red">
                                                            *
                                                        </span>
                                                    </label>

                                                    <input
                                                        type="number"
                                                        name="price"
                                                        className="form-control"
                                                        value={
                                                            formValues.price
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                        placeholder="Enter ticket price"
                                                        min="0"
                                                        required
                                                    />

                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        Ticket Discount
                                                        <span className="red">
                                                            *
                                                        </span>
                                                    </label>

                                                    <input
                                                        type="number"
                                                        name="ticket_discount"
                                                        className="form-control"
                                                        value={
                                                            formValues.ticket_discount
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                        placeholder="Enter ticket price"
                                                        min="0"

                                                    />

                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        General Ticket Discount
                                                        <span className="red">
                                                            *
                                                        </span>
                                                    </label>

                                                    <input
                                                        type="number"
                                                        name="general_ticket_discount"
                                                        className="form-control"
                                                        value={
                                                            formValues.general_ticket_discount
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                        placeholder="Enter ticket price"
                                                        min="0"

                                                    />

                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-sm-12">
                                                <div className="input-field">

                                                    <label>
                                                        Benifits
                                                    </label>

                                                    <textarea
                                                        name="description"
                                                        className="form-control video-desc"
                                                        value={
                                                            formValues.description
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                        placeholder="Enter ticket description"
                                                        rows="4"
                                                    />

                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        Status
                                                    </label>

                                                    <select
                                                        name="status"
                                                        className="form-control"
                                                        value={
                                                            formValues.status
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                    >
                                                        <option value="Active">
                                                            Active
                                                        </option>

                                                        <option value="Inactive">
                                                            Inactive
                                                        </option>
                                                    </select>

                                                </div>
                                            </div>

                                            {/* =========================
                                                IMAGE
                                            ========================== */}
                                            {/* <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        Ticket Image
                                                    </label>

                                                    <input
                                                        type="file"
                                                        name="ticketImage"
                                                        className="form-control"
                                                        accept="image/*"
                                                        onChange={
                                                            handleFileChange
                                                        }
                                                    />

                                                    <div className="file-preview text-center mt-2">

                                                        <img
                                                            src={
                                                                previewImage
                                                            }
                                                            alt="Ticket"
                                                            style={{
                                                                width: "120px",
                                                                height: "120px",
                                                                objectFit:
                                                                    "cover",
                                                                borderRadius:
                                                                    "8px",
                                                            }}
                                                        />

                                                    </div>

                                                </div>
                                            </div> */}

                                        </div>

                                        {/* =========================
                                            SUBMIT
                                        ========================== */}
                                        <button
                                            className="submit-green-btn"
                                            type="submit"
                                            disabled={loading}
                                        >
                                            {loading
                                                ? "Updating..."
                                                : "Submit"}
                                        </button>

                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default UpdateEventCategory;